import React, { useState, useEffect } from 'react';
import './SidebarItem.css';
import {
  Typography,
  TextField,
  Dialog,
  Button,
  IconButton,
  useMediaQuery,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import {
  getBoardInfo,
  setBoardInfo,
  setSpaceId,
  setSpaceName,
} from '../../Utils/authentication-access';
import boardsService from '../../services/boards.service';
import { showSpinner, hideSpinner } from '../../store/actions/notification.action';
import BoardInfo from './BoardInfo.jsx';
import SpaceInfo from './SpaceInfo';
import { spacesService } from '../../services/spaces.service';
import PubSub from 'pubsub-js';
import { EVENTS } from '../../constants/events';
import RenameSpace from './Dialogs/RenameSpace';
import { useDispatch, useSelector } from 'react-redux';
import { activeSpaceInfo } from '../../store/actions/spaces.action';
import DeleteSpaceDialog from './Dialogs/DeleteSpaceDialog';
import AddCircleIcon from '../../assets/icons/addCircleIcon';
import { useNotificationDispatcher } from '../../store/dispatcher/useNotificationDispatcher';
import { useDialogDispatcher } from '../../store/dispatcher/useDialogDispatcher';

const ITEM_HEIGHT = 48;

const SidebarItem = (props) => {
  const [open, setOpen] = useState(false);
  const [boardName, setBoardName] = useState('');
  const [boardInput, setBoardInput] = useState(false);
  const [saveParentId, setSaveParentId] = useState('');
  const [saveParentName, setSaveParentName] = useState('');
  const {
    item,
    childCountChange,
    spacesCount,
    isDrawerOpen,
    setActiveBoard,
    activeBoard,
    setSelectedSpaces,
    selectedSpaces,
    sortHandler,
    sortType,
  } = props;
  const [renameDialogOpen, setRenameDialogOpen] = useState(false);
  const [renameBoardInput, setRenameBoardInput] = useState('');
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteBoardInput, setDeleteBoardInput] = useState('');

  const [renameSpaceDialogOpen, setRenameSpaceDialogOpen] = useState(false);
  const [renameSpaceBoardInput, setRenameSpaceBoardInput] = useState('');
  const [deleteSpaceDialogOpen, setDeleteSpaceDialogOpen] = useState(false);
  const [deleteSpaceBoardInput, setDeleteSpaceBoardInput] = useState('');
  const [parentName, setParentName] = useState('');

  const [renameBoardData, setRenameBoardData] = useState('');
  const [deleteBoardData, setDeleteBoardData] = useState('');

  const [renameSpaceData, setRenameSpaceData] = useState('');
  const [deleteSpaceData, setDeleteSpaceData] = useState('');

  const [createBoardErrorTextMessage, setCreateBoardErrorTextMessage] = useState('');

  const [renameSpaceErrorTextMessage, setRenameSpaceErrorTextMessage] = useState('');

  const [boardRenameErrorTextMessage, setBoardRenameErrorTextMessage] = useState('');

  const [boardMenu, setBoardMenu] = useState(0);
  const isMobileView = useMediaQuery('(max-width:600px)');
  const { dispatchSetSnackbar, dispatchShowLicenseExhaustedDialog } = useNotificationDispatcher();
  const cloudLicenseInfo = useSelector((state) => state.licenseReducer.cloudLicenseDetails);
  const { dispatchSetIsOpenNavigationSidebarDialog } = useDialogDispatcher();

  let canvasInfo = 0;

  const [nCount, setNcount] = useState(0);

  const [boardsData, setBoardsData] = useState([]);
  const dispatch = useDispatch();

  const enterBoardName = () => {
    if (
      cloudLicenseInfo.spaces.isUnlimited ||
      item.childrens.length < cloudLicenseInfo.spaces.totalLimit
    ) {
      setBoardInput(true);
      console.log('ParentId', saveParentId);
    } else {
      dispatchShowLicenseExhaustedDialog();
    }
  };

  useEffect(() => {
    setBoardsData(item.childrens);
  }, [item]);

  useEffect(() => {
    boardSortHandler();
  }, [sortType]);

  const boardSortHandler = () => {
    if (boardsData.length != 0) {
      if (sortType === 'Name') {
        sortByName();
      } else if (sortType === 'Date Created') {
        sortSpacesByDate();
      } else if (sortType === 'Last Modified') {
        sortSpacesByUpdated();
      } else {
        sortByName();
      }
    }
  };

  const sortByName = () => {
    let updatedList = [...boardsData];

    updatedList = updatedList.sort(function (a, b) {
      if (a.name.toLowerCase() < b.name.toLowerCase()) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    });
    setBoardsData(updatedList);
  };

  const sortSpacesByDate = () => {
    let updatedList = [...boardsData];
    updatedList = updatedList.sort(function (a, b) {
      if (a.createdAt < b.createdAt) {
        return 1;
      }
      if (a.createdAt > b.createdAt) {
        return -1;
      }
      return 0;
    });
    setBoardsData(updatedList);
  };

  const sortSpacesByUpdated = () => {
    let updatedList = [...boardsData];
    updatedList = updatedList.sort(function (a, b) {
      if (a.updatedAt < b.updatedAt) {
        return 1;
      }
      if (a.updatedAt > b.updatedAt) {
        return -1;
      }
      return 0;
    });
    setBoardsData(updatedList);
  };

  useEffect(() => {
    setSaveParentId(item.id);
    setSaveParentName(item.name);
  }, [boardInput]);

  const handleClose = () => {
    setBoardInput(false);
    setRenameDialogOpen(false);
    setDeleteDialogOpen(false);
    setRenameSpaceDialogOpen(false);
    setDeleteSpaceDialogOpen(false);

    setBoardMenu(boardMenu + 1);
  };

  const CreateBoard = async () => {
    try {
      if (boardName !== '') {
        setCreateBoardErrorTextMessage('');
        const res = await boardsService.createBoard(boardName, saveParentId);
        setBoardName('');
        setNcount((childCount) => childCount + 2);
        childCountChange(nCount);
        handleClose();
        //Redirect to newly created space start
        openBoard(res.data.data);
        //Redirect to newly created space end
      } else {
        setCreateBoardErrorTextMessage('*Required');
      }
    } catch (error) {
      console.log('error', error.response.data.message);
      dispatchSetSnackbar({ message: error.response.data.message });
    }
  };

  useEffect(() => {
    //it's for closing sidebar  if user switch spaces
    const from = localStorage.getItem('from');
    if (from) {
      dispatchSetIsOpenNavigationSidebarDialog(false);
      localStorage.removeItem('from');
    }
  }, []);

  const openBoard = async (child) => {
    dispatch(showSpinner());
    await setBoardInfoData(child.meta.classId);
    dispatch(hideSpinner());
    setSpaceId(child.parentId);
    setSpaceName(item.name);
    localStorage.setItem('from', child.parentId);
    window.location.reload();

    //commented for texting
    // let boardData = JSON.parse(localStorage.getItem('boardinfo'));
    // setActiveBoard(boardData);
    // PubSub.publish(EVENTS.BOARD_CHANGED, {});
  };

  useEffect(() => {
    let boardData = getBoardInfo();

    setActiveBoard(boardData);
  }, [isDrawerOpen]);

  const setBoardInfoData = async (classID) => {
    const response = await boardsService.getBoards(classID);

    const classInfo = response.data.data;

    const { email, hardwareId, name, flowId, classId } = classInfo;
    canvasInfo = {
      email,
      hardwareId,
      name,
      flowId,
      classId,
    };
    setBoardInfo(canvasInfo);
  };

  const renameBoard = (data) => {
    let { board, ParentName } = data;

    setRenameDialogOpen(true);
    setRenameBoardInput(board.name);

    setParentName(ParentName);

    setRenameBoardData(data.board);
  };

  const deleteBoard = (data) => {
    setDeleteDialogOpen(true);
    setDeleteBoardInput(data.name);

    setDeleteBoardData(data);
  };

  const renameSpace = (data) => {
    setRenameSpaceDialogOpen(true);
    setRenameSpaceBoardInput(data.name);

    setRenameSpaceData(data);
  };

  const deleteSpace = (data) => {
    setDeleteSpaceDialogOpen(true);
    setDeleteSpaceBoardInput(data.name);

    setDeleteSpaceData(data);
  };

  const reNameBoardClick = async () => {
    const flowID = renameBoardData.meta.flowId;
    const classID = renameBoardData.meta.classId;
    if (renameBoardInput !== '') {
      setBoardRenameErrorTextMessage('');
      await boardsService.renameBoard(flowID, classID, renameBoardInput);

      const boardInfo = getBoardInfo();
      console.log('boardInfo', boardInfo);

      if (classID == getBoardInfo().classId) {
        boardInfo.name = renameBoardInput;
        setBoardInfo(boardInfo);
        dispatch(activeSpaceInfo(boardInfo));
      }

      childCountChange();
      setRenameDialogOpen(false);
      setBoardMenu(boardMenu + 1);
    } else {
      setBoardRenameErrorTextMessage('*Required');
    }
  };

  //INFO : boards currently named as spaces

  const deleteBoardClick = async () => {
    const flowID = deleteBoardData.meta.flowId;
    const classID = deleteBoardData.meta.classId;

    await boardsService.deleteBoard(flowID, classID);
    childCountChange();
    setDeleteDialogOpen(false);
    setBoardMenu(boardMenu + 1);
  };

  const DuplicateBoard = async ({ board, childLength }) => {
    if (cloudLicenseInfo.spaces.isUnlimited || childLength < cloudLicenseInfo.spaces.totalLimit) {
      const flowID = board.meta.flowId;
      const classID = board.meta.classId;
      const spaceID = board.parentId;

      await boardsService.duplicateBoard(flowID, classID, spaceID);
      childCountChange();
      setBoardMenu(boardMenu + 1);
    } else {
      dispatchShowLicenseExhaustedDialog();
    }
  };

  const deleteSpaceClick = async () => {
    const spaceID = deleteSpaceData.id;

    await spacesService.deleteSpace(spaceID);
    childCountChange();
    setDeleteSpaceDialogOpen(false);
    setBoardMenu(boardMenu + 1);
  };

  const renameSpaceClick = async () => {
    if (renameSpaceBoardInput !== '') {
      setRenameSpaceErrorTextMessage('');
      const spaceID = renameSpaceData.id;
      await spacesService.renameSpace(spaceID, renameSpaceBoardInput);
      childCountChange();
      setRenameSpaceDialogOpen(false);
      setBoardMenu(boardMenu + 1);
      sortHandler();
    } else {
      setRenameSpaceErrorTextMessage('*Required');
    }
  };

  const onEnterKeyPressRenameSpace = (e) => {
    if (e.key === 'Enter') {
      renameSpaceClick();
    }
  };

  const onEnterKeyPressRenameBoard = (e) => {
    if (e.key === 'Enter') {
      reNameBoardClick();
    }
  };

  const onEnterKeyPressCreateBoard = (e) => {
    if (e.key === 'Enter') {
      CreateBoard();
    }
  };

  const handleRenameBoardInput = (event) => {
    setRenameBoardInput(event.target.value);
  };

  ////

  if (item.childrens) {
    return (
      <>
        <div className={selectedSpaces.includes(item.id) ? 'sidebar-item open' : 'sidebar-item'}>
          <SpaceInfo
            spacesCount={spacesCount}
            item={item}
            setOpen={setOpen}
            open={open}
            renameSpace={renameSpace}
            deleteSpace={deleteSpace}
            menuOptionsClose={boardMenu}
            enterBoardName={enterBoardName}
            isDrawerOpen={isDrawerOpen}
            selectedSpaces={selectedSpaces}
            setSelectedSpaces={setSelectedSpaces}
          />

          <div className="sidebar-content">
            {boardsData.map((board) => (
              <BoardInfo
                key={board.id}
                activeBoard={activeBoard}
                menuOptionsClose={boardMenu}
                childLength={item.childrens.length}
                ParentName={item.name}
                board={board}
                openBoard={openBoard}
                renameBoard={renameBoard}
                deleteBoard={deleteBoard}
                DuplicateBoard={DuplicateBoard}
              />
            ))}
          </div>

          <div className="sidebar-content boardAdd" onClick={enterBoardName}>
            <div style={{ display: 'contents' }}>
              <div style={{ marginRight: '7px', display: 'flex' }}>
                <AddCircleIcon />
              </div>
              <div>Add space</div>
            </div>
          </div>
        </div>

        <Dialog
          open={boardInput}
          onClose={handleClose}
          fullWidth={true}
          maxWidth={'sm'}
          PaperProps={{
            style: {
              borderRadius: 16,
            },
          }}
        >
          <div
            style={{
              padding: ' 2% 2%',
              display: 'grid',
              gridTemplateColumns: '90% 10%',
              alignItems: 'center',
              minHeight: '30px',
              borderBottom: '1px solid rgba(0,0,0,0.12)',
            }}
          >
            <div
              style={{
                fontFamily: 'Roboto',
                fontStyle: 'normal',
                fontWeight: 500,
                fontSize: '20px',
                lineHeight: '28px',
                textAlign: 'center',
                marginLeft: '50px',
                color: 'rgba(0, 0, 0)',
              }}
            >
              {' '}
              Create a new Space
            </div>
            <IconButton
              edge="end"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
              style={{ marginRight: 10, cursor: 'pointer', marginTop: '2px' }}
            >
              <CloseIcon />
            </IconButton>
          </div>

          <div style={{ margin: '29px' }}>
            <Typography
              variant="h6"
              component="div"
              style={{
                fontFamily: 'Roboto',
                fontStyle: 'normal',
                fontWeight: 500,
                fontSize: '10px',
                lineHeight: '16px',
                color: 'rgba(0, 0, 0, 0.87)',
              }}
            >
              Space Name
            </Typography>
            <TextField
              autoFocus
              id="name"
              type="name"
              style={{ width: `${isMobileView ? '100%' : '423px'}` }}
              value={boardName}
              variant="outlined"
              onChange={(event) => setBoardName(event.target.value)}
              onKeyDown={onEnterKeyPressCreateBoard}
              helperText={createBoardErrorTextMessage}
            />
            <div className="TeamName">Team: {saveParentName}</div>
          </div>

          <div
            style={{
              borderTop: '1px solid rgba(0,0,0,0.12)',
              flex: '0 0 auto',
              display: 'flex',
              padding: '12px',
              paddingBottom: '21px',
              alignItems: 'center',
              justifyContent: 'flex-end',
            }}
          >
            <Button
              onClick={handleClose}
              style={{
                width: '100px',
                height: '36px',
                borderRadius: '4px',
                border: '1px solid rgba(0, 0, 0, 0.12)',
                color: 'rgba(0, 0, 0, 0.38)',
              }}
            >
              {' '}
              CANCEL
            </Button>

            <Button
              style={{
                marginLeft: '5px',
                width: '100px',
                height: '36px',
                background: '#335AFB',
                boxShadow: '0px 0.3px 0.5px rgba(0, 0, 0, 0.1), 0px 2px 4px rgba(0, 0, 0, 0.2)',
                borderRadius: '4px',
                color: 'white',
              }}
              onClick={CreateBoard}
            >
              SAVE
            </Button>
          </div>
        </Dialog>

        <RenameSpace
          renameDialogOpen={renameDialogOpen}
          handleClose={handleClose}
          renameBoardInput={renameBoardInput}
          handleRenameBoardInput={handleRenameBoardInput}
          onEnterKeyPressRenameBoard={onEnterKeyPressRenameBoard}
          boardRenameErrorTextMessage={boardRenameErrorTextMessage}
          parentName={parentName}
          reNameBoardClick={reNameBoardClick}
        />

        <Dialog
          open={renameDialogOpen}
          onClose={handleClose}
          fullWidth={true}
          maxWidth={'sm'}
          PaperProps={{
            style: {
              borderRadius: 16,
            },
          }}
        >
          <div
            style={{
              padding: ' 2% 2%',
              display: 'grid',
              gridTemplateColumns: '90% 10%',
              alignItems: 'center',
              minHeight: '30px',
              borderBottom: '1px solid rgba(0,0,0,0.12)',
            }}
          >
            <div
              style={{
                fontFamily: 'Roboto',
                fontStyle: 'normal',
                fontWeight: 500,
                fontSize: '20px',
                lineHeight: '28px',
                textAlign: 'center',
                marginLeft: '50px',
                color: 'rgba(0, 0, 0)',
              }}
            >
              {' '}
              Rename Space
            </div>
            <IconButton
              edge="end"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
              style={{ marginRight: 10, cursor: 'pointer' }}
            >
              <CloseIcon />
            </IconButton>
          </div>

          <div style={{ margin: '29px' }}>
            <Typography
              variant="h6"
              component="div"
              style={{
                fontFamily: 'Roboto',
                fontStyle: 'normal',
                fontWeight: 500,
                fontSize: '10px',
                lineHeight: '16px',
                color: 'rgba(0, 0, 0, 0.87)',
              }}
            >
              Space Name
            </Typography>
            <TextField
              autoFocus
              id="name"
              type="name"
              style={{ width: `${isMobileView ? '100%' : '423px'}` }}
              value={renameBoardInput}
              variant="outlined"
              onChange={(event) => setRenameBoardInput(event.target.value)}
              onKeyDown={onEnterKeyPressRenameBoard}
              helperText={boardRenameErrorTextMessage}
            />

            <div className="ParentName">Team: {parentName}</div>
          </div>

          <div
            style={{
              borderTop: '1px solid rgba(0,0,0,0.12)',
              flex: '0 0 auto',
              display: 'flex',
              padding: '12px',
              paddingBottom: '21px',
              alignItems: 'center',
              justifyContent: 'flex-end',
            }}
          >
            <Button
              onClick={handleClose}
              style={{
                width: '100px',
                height: '36px',
                borderRadius: '4px',
                border: '1px solid rgba(0, 0, 0, 0.12)',
                color: 'rgba(0, 0, 0, 0.38)',
              }}
            >
              {' '}
              CANCEL
            </Button>

            <Button
              style={{
                marginLeft: '5px',
                width: '100px',
                height: '36px',
                background: '#335AFB',
                boxShadow: '0px 0.3px 0.5px rgba(0, 0, 0, 0.1), 0px 2px 4px rgba(0, 0, 0, 0.2)',
                borderRadius: '4px',
                color: 'white',
              }}
              onClick={reNameBoardClick}
            >
              SAVE
            </Button>
          </div>
        </Dialog>

        <DeleteSpaceDialog
          deleteDialogOpen={deleteDialogOpen}
          handleClose={handleClose}
          deleteBoardInput={deleteBoardInput}
          deleteBoardClick={deleteBoardClick}
        />

        <Dialog
          open={renameSpaceDialogOpen}
          onClose={handleClose}
          fullWidth={true}
          maxWidth={'sm'}
          PaperProps={{
            style: {
              borderRadius: 16,
            },
          }}
        >
          <div
            style={{
              padding: ' 2% 2%',
              display: 'grid',
              gridTemplateColumns: '90% 10%',
              alignItems: 'center',
              minHeight: '30px',
              borderBottom: '1px solid rgba(0,0,0,0.12)',
            }}
          >
            <div
              style={{
                fontFamily: 'Roboto',
                fontStyle: 'normal',
                fontWeight: 500,
                fontSize: '20px',
                lineHeight: '28px',
                textAlign: 'center',
                marginLeft: '50px',
                color: 'rgba(0, 0, 0)',
              }}
            >
              {' '}
              Rename Team
            </div>
            <IconButton
              edge="end"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
              style={{ marginRight: 10, cursor: 'pointer', marginTop: '2px' }}
            >
              <CloseIcon />
            </IconButton>
          </div>

          <div style={{ margin: '29px' }}>
            <Typography
              variant="h6"
              component="div"
              style={{
                fontFamily: 'Roboto',
                fontStyle: 'normal',
                fontWeight: 500,
                fontSize: '10px',
                lineHeight: '16px',
                color: 'rgba(0, 0, 0, 0.87)',
              }}
            >
              Team Name
            </Typography>
            <TextField
              autoFocus
              id="name"
              type="name"
              style={{ width: `${isMobileView ? '100%' : '423px'}` }}
              value={renameSpaceBoardInput}
              variant="outlined"
              onChange={(event) => setRenameSpaceBoardInput(event.target.value)}
              onKeyDown={onEnterKeyPressRenameSpace}
              helperText={renameSpaceErrorTextMessage}
            />
          </div>

          <div
            style={{
              borderTop: '1px solid rgba(0,0,0,0.12)',
              flex: '0 0 auto',
              display: 'flex',
              padding: '12px',
              paddingBottom: '21px',
              alignItems: 'center',
              justifyContent: 'flex-end',
            }}
          >
            <Button
              onClick={handleClose}
              style={{
                width: '100px',
                height: '36px',
                borderRadius: '4px',
                border: '1px solid rgba(0, 0, 0, 0.12)',
                color: 'rgba(0, 0, 0, 0.38)',
              }}
            >
              {' '}
              CANCEL
            </Button>

            <Button
              style={{
                marginLeft: '5px',
                width: '100px',
                height: '36px',
                background: '#335AFB',
                boxShadow: '0px 0.3px 0.5px rgba(0, 0, 0, 0.1), 0px 2px 4px rgba(0, 0, 0, 0.2)',
                borderRadius: '4px',
                color: 'white',
              }}
              onClick={renameSpaceClick}
            >
              SAVE
            </Button>
          </div>
        </Dialog>

        <Dialog
          open={deleteSpaceDialogOpen}
          onClose={handleClose}
          fullWidth={true}
          maxWidth={'sm'}
          PaperProps={{
            style: {
              borderRadius: 16,
            },
          }}
        >
          <div
            style={{
              padding: ' 2% 2%',
              display: 'grid',
              gridTemplateColumns: '90% 10%',
              alignItems: 'center',
              minHeight: '30px',
              borderBottom: '1px solid rgba(0,0,0,0.12)',
            }}
          >
            <div
              style={{
                fontFamily: 'Roboto',
                fontStyle: 'normal',
                fontWeight: 500,
                fontSize: '20px',
                lineHeight: '28px',
                textAlign: 'center',
                marginLeft: '50px',
                color: 'rgba(0, 0, 0)',
              }}
            >
              {' '}
              Delete Team?
            </div>
            <IconButton
              edge="end"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
              style={{ marginRight: 10, cursor: 'pointer' }}
            >
              <CloseIcon />
            </IconButton>
          </div>

          <div style={{ margin: '29px', marginBottom: '59px' }}>
            <div className="deleteContentText">
              <div>Are you sure you want to delete {deleteSpaceBoardInput}?</div>
              <div className="deleteTextRed">(You can’t undo this action once deleted)</div>
            </div>
          </div>

          <div
            style={{
              borderTop: '1px solid rgba(0,0,0,0.12)',
              flex: '0 0 auto',
              display: 'flex',
              padding: '12px',
              paddingBottom: '21px',
              alignItems: 'center',
              justifyContent: 'flex-end',
            }}
          >
            <Button
              onClick={handleClose}
              style={{
                width: '100px',
                height: '36px',
                borderRadius: '4px',
                border: '1px solid rgba(0, 0, 0, 0.12)',
                color: 'rgba(0, 0, 0, 0.38)',
              }}
            >
              {' '}
              CANCEL
            </Button>

            <Button
              style={{
                marginLeft: '5px',
                width: '100px',
                height: '36px',
                background: '#335AFB',
                boxShadow: '0px 0.3px 0.5px rgba(0, 0, 0, 0.1), 0px 2px 4px rgba(0, 0, 0, 0.2)',
                borderRadius: '4px',
                color: 'white',
              }}
              onClick={deleteSpaceClick}
            >
              DELETE
            </Button>
          </div>
        </Dialog>
      </>
    );
  } else {
    return (
      <a href={item.path || '#'} className="sidebar-item plain">
        {item.icon && <i className={item.icon}></i>}
        {item.name}
      </a>
    );
  }
};

export default SidebarItem;
